import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';
import { TelegramAccount } from '../../../shared/types/TelegramAccount';
import { TelegramAccountEntity } from '../../../domain/entities/TelegramAccount';

export class UpdateTelegramAccountUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(uuid: string, input: Partial<Pick<TelegramAccount, 'status'>>): Promise<TelegramAccountEntity> { return this.repo.update(uuid, input); }
}
